import ScriptIcon from './component.jsx'
export default ScriptIcon
